import React, { useEffect, useState } from 'react';

import { App, Modal, Skeleton, theme } from 'antd';
import 'ckeditor5/ckeditor5.css';
import dayjs from 'dayjs';
import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ApiErrorData } from 'models/ApiResponse';
import { DashboardNew } from 'models/DashboardNew';

import { DashboardNewService } from 'services/DashboardNewService';

import { FunctionsHelper } from 'utils/FunctionsHelper';

import appI18n from '../../../config/i18n';

interface DetailCarouselModalProps {
  isOpen: boolean;
  handleModalCancel: () => void;
  item: DashboardNew;
}

function DetailCarouselModal({
  isOpen,
  handleModalCancel,
  item,
}: DetailCarouselModalProps) {
  const { token } = theme.useToken();
  const { t } = useTranslation(undefined, { i18n: appI18n });
  const { message } = App.useApp();
  const [content, setContent] = useState<string | undefined>(undefined);
  const [loadingContent, setLoadingContent] = useState(true);

  useEffect(() => {
    // Siempre arranca en loading=true para que el skeleton sea inmediato
    setLoadingContent(true);
    setContent(undefined);

    let cancelled = false;

    DashboardNewService.findById(item.id).then((response) => {
      if (cancelled) return;

      if (response.success) {
        const data = response.data as DashboardNew;
        setContent(data.content || '');
      } else {
        const error = response.data as ApiErrorData;
        message.error(
          (error.message as string) || t('common.messages.fetch_news_error'),
          3.5
        );
      }

      setLoadingContent(false);
    });

    return () => {
      cancelled = true;
    };
  }, [item.id]);

  return (
    <Modal
      className="news-modal"
      open={isOpen}
      onCancel={handleModalCancel}
      maskClosable={false}
      destroyOnClose
      footer={null}
      width={800}
    >
      <div className="news-modal-content">
        <img src={item.logoUrl} alt={item.title} className="news-image" />
        <div className="news-date">
          <Calendar
            size={14}
            className="chome-date-icon"
            style={{ marginRight: '3.5px' }}
          />{' '}
          {item.publishedDate
            ? FunctionsHelper.capitalizeFirstLetter(
                dayjs(item.publishedDate).format('MMMM D, YYYY')
              )
            : ''}
        </div>
        <h1 className="news-title" style={{ color: token.colorPrimary }}>
          {item.title}
        </h1>
        {loadingContent ? (
          <div style={{ padding: '0 24px 24px' }}>
            <Skeleton active paragraph={{ rows: 6 }} title={false} />
          </div>
        ) : (
          <div
            className="news-body ck-content"
            dangerouslySetInnerHTML={{ __html: content || '' }}
          />
        )}
      </div>
    </Modal>
  );
}

export default DetailCarouselModal;
